import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

function AboutMain({ getLink, getData }) {
  const [moreBtn, setMoreBtn] = useState([false, false, false, false, false]);
  const [scrollPosition, setScrollPosition] = useState(0);

  const onMoreBtn = (idx, doOpen) => {
    const copy = [...moreBtn];
    copy[idx] = doOpen;
    setMoreBtn(copy);
  };

  useEffect(() => {
    getLink(window.location.href);
    getData(
      "회사소개",
      "현실과 가상의 공간을 시간을 통해 이야기를 만들고",
      "태양처럼 인간을 위한 공간 가치 창출에 도전하겠습니다"
    );
    window.addEventListener("scroll", updateScroll);
  }, [getLink, getData]);

  // 스크롤 pc
  const updateScroll = () => {
    setScrollPosition(window.scrollY || document.documentElement.scrollTop);
  };

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  return (
    <>
      {pc ? (
        <>
          <div>
            <div
              className={
                scrollPosition > 499
                  ? "basic-banner about-banner on"
                  : "basic-banner about-banner"
              }
            >
              <h2 className="basic-banner-title">
                <p className="txt">We Connect Space</p>
                <p className="txt">And Humans</p>
                <p className="basic-banner-subtitle">
                  공간과 인간을 연결하는 가치 창조자 HELIOSEN
                </p>
              </h2>
            </div>
            <div className="about-heliosen-wrap inner">
              <div>
                <h2 className="about-welcome">
                  <p className="txt">헬리오센을 방문해주신</p>
                  <p className="txt">여러분 진심으로 환영합니다.</p>
                </h2>
                <p className="about-ceo">대표이사 이종훈</p>
              </div>
              <div className="about-heliosen">
                <h3 className="about-heliosen-title">
                  <p className="txt">
                    Heliosen은 Helios(그리스 신화의 태양신)와
                  </p>
                  <p className="txt">Sense(감각)의 합성어입니다.</p>
                </h3>
                <div className="about-heliosen-top-cont">
                  <p>
                    바깥으로는 디지털 트윈과 메타버스 시대에 맞는 직관적인
                    표현과 통찰력 있는
                  </p>
                  <p>
                    분석기술을 제공하여 공간과 인간을 연결하고, 내적으로는
                    배려와 공감과 상호 존중을
                  </p>
                  <p>
                    바탕으로 창의적이고 진취적 마인드를 갖춘 전문가 집단으로
                    능력 개발과 발휘를 통하여
                  </p>
                  <p>사회와 같이 성장하는 회사가 되고자 합니다.</p>
                  <div className="about-heliosen-bottom-cont">
                    <p>여러분의 관심을 바탕으로 신뢰를 쌓으며,</p>
                    <p>
                      인간과 공간과 시간 사이를 좁히는 가치 창출에
                      노력하겠습니다.
                    </p>
                  </div>
                  <p>
                    <b className="basic-bold">감사합니다.</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="inner">
            <div className="about-overview">
              <p className="about-overview-img"></p>
              <div className="about-overview-txt-wrap">
                <div className="about-overview-txt">
                  <h2 className="about-overview-main-txt">기업 개요</h2>
                  <p>디지털 트윈 선도 업체로 분야의 다양한 경험과</p>
                  <p>기술을 보유한 인원으로 구성되어 있습니다.</p>
                </div>
                <div>
                  <ul className="about-overview-list">
                    <li className="about-overview-item">
                      <p className="about-overview-name">회사명</p>
                      <h4 className="about-overview-cont">헬리오센(주)</h4>
                    </li>
                    <li className="about-overview-item">
                      <p className="about-overview-name">대표이사</p>
                      <h4 className="about-overview-cont">이종훈</h4>
                    </li>
                    <li className="about-overview-item">
                      <p className="about-overview-name">업종</p>
                      <h4 className="about-overview-cont">
                        정보통신업 / 서비스업
                      </h4>
                    </li>
                    <li className="about-overview-item">
                      <p className="about-overview-name">설립일</p>
                      <h4 className="about-overview-cont">2020. 02. 04</h4>
                    </li>
                    <li className="about-overview-item about-overview-img-item">
                      <div>
                        <p className="about-overview-img about-overview-patent-img"></p>
                        <p className="about-overview-cont">특허 등록</p>
                      </div>
                      <h4 className="about-overview-cont">14 건</h4>
                    </li>
                    <li className="about-overview-item about-overview-img-item">
                      <div>
                        <p className="about-overview-img about-overview-copyright-img"></p>
                        <p className="about-overview-cont">저작권 등록</p>
                      </div>
                      <h4 className="about-overview-cont">28 건</h4>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <ul className="about-historys-list">
                <li className="about-historys-item">
                  <h3 className="about-history-title">2024</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">11월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div style={{ marginBottom: "20px" }}>
                            <p className="basic-bold">
                              3차원 공간정보데이터의 고속연산 처리를
                            </p>
                            <p className="basic-bold">위한 다중검증 시스템</p>
                          </div>
                        </div>
                        <p className="basic-bold">
                          제16회 2024 K-GEO Festa 참가
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">10월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div style={{ marginBottom: "20px" }}>
                            <p className="basic-bold">
                              3D Tiles Next 생성 소프트웨어 v1.0
                            </p>
                            <p className="basic-bold">
                              (쓰리디 타일즈 넥스트 생성 소프트웨어 버전 1.0)
                            </p>
                          </div>
                        </div>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          연세대학교 의료원 산학협력단 공동연구개발협약 체결
                        </p>
                        <p className="basic-bold">
                          'DiTAP Builder v1.0' 나라장터 "상용소프트웨어
                        </p>
                        <p className="basic-bold">제3자단가 계약" 완료</p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">09월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          성남시 측량업-공공측량업 등록
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          국토지리정보원 측량업-수치지도제작업 등록
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          국토지리정보원 측량업-영상처리업 등록
                        </p>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div style={{ marginBottom: "20px" }}>
                            <p className="basic-bold">
                              Smart Hospital Vulnerable Simulation
                            </p>
                            <p className="basic-bold">
                              System v1 (스마트 병원 취약지점 분석
                            </p>
                            <p className="basic-bold">시뮬레이션 시스템)</p>
                          </div>
                        </div>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div style={{ marginBottom: "20px" }}>
                            <p className="basic-bold">
                              Smart Hospital Indoor Viewer
                            </p>
                            <p className="basic-bold">
                              System v1.0(스마트 병원 실내 데이터
                            </p>
                            <p className="basic-bold">가시화 시스템)</p>
                          </div>
                        </div>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div style={{ marginBottom: "20px" }}>
                            <p className="basic-bold">
                              Smart Hospital RTLS System v1.0
                            </p>
                            <p className="basic-bold">
                              (스마트 병원 이동객체 시스템)
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">08월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          국토교통부 초경량비행장치사용사업 등록
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">07월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          국토지리정보원 측량업-지도제작업 등록
                        </p>
                        <p className="basic-bold">
                          YTN '최강기업' 프로그램 헬리오센 출연
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">06월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              3차원 디지털 트윈 플랫폼 서비스를 위한 사용자
                            </p>
                            <p className="basic-bold">
                              솔루션 및 클라우드 구독용 서비스의 제공 방법
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">05월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          한국일보 '디지털 이노베이션 대상' 수상
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">03월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          본사 이전 &#40;경기도 성남시 분당구 판교역로 230
                        </p>
                        <p className="basic-bold">
                          삼환하이펙스 B동 B101호&#41;
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">01월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          ISO9001 인증 획득
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          'DiTAP_Builder, JS, for Unity' 나라장터 등록 완료
                        </p>
                        <p className="basic-bold">청년친화강소기업 선정</p>
                      </div>
                    </li>
                  </ul>
                </li>
                <li className="about-historys-item">
                  <h3 className="about-history-title">2023</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">12월</p>
                      <div className="about-history-cont">
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              XR(확장현실)기반 3차원 모델 가시화
                            </p>
                            <p className="basic-bold">프로그램 v2.0</p>
                          </div>
                        </div>
                        <p className="basic-bold">
                          저작권 등록 - IndoorHospital(인도어호스피탈) v0.1
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">11월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          GS인증 1급 취득 - DiTAP Builder (다이탭 빌더)
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          GS인증 1급 취득 - DiTAP JS (다이탭 제이에스)
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          GS인증 1급 취득 - DiTAP Unity (다이탭 유니티)
                        </p>
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              CAD(캐드)BIM(빌딩정보모델링) 데이터
                            </p>
                            <p className="basic-bold">
                              대용량 검증처리 모듈 v1.0
                            </p>
                          </div>
                        </div>
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              CAD(캐드)BIM(빌딩정보모델링)데이터
                            </p>
                            <p className="basic-bold">언팩 &정합모듈 v1.0</p>
                          </div>
                        </div>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              25.DiTAP 3D Converter(다이탭 쓰리디
                            </p>
                            <p className="basic-bold">
                              타일쓰 비아이엠 모델 경량화 소프트웨어)
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">09월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAP for Unity v1.0 (다이탭 포 유니티)
                        </p>
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              R-tree 기반을 활용한 3차원 건축물 실내외
                            </p>
                            <p className="basic-bold">
                              3D Tiles 자동 생성 시스템
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">08월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAP JS v1.0 (다이탭 제이에스)
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAP Builder v1.0 (다이탭 빌더)
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          기술혁신형 중소기업(Inno-Biz) 인증
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">06월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              유니티(Unity)엔진을 이용한 3차원 지구
                            </p>
                            <p className="basic-bold">XR 가시화 장치 및 방법</p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">05월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAPforUnity XR
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAPforUnity XR - Architecture
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAPforUnity XR - Museum
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAPforUnity XR - UrbanPlanning
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - 3D Tiles 자동화 모듈(3차원 타일 자동화
                          모듈)
                        </p>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              DiTAP Server 대용량 데이터 파이프라인
                            </p>
                            <p className="basic-bold">
                              (다이탭 서버 대용량 데이터 파이프라인)
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">04월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              비공간정보와 3차원 공간정보 매핑데이터를
                            </p>
                            <p className="basic-bold">
                              가시화 시킨 검증기술 시스템 및 방법
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">03월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              비공간정보와 3차원 공간정보 매핑데이터의
                            </p>
                            <p className="basic-bold">
                              신뢰도를 향상시킨 고속검색 시스템 및 방법
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li className="about-historys-item">
                  <h3 className="about-history-title">2022</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">12월</p>
                      <div className="about-history-cont">
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              3D Unstructured data rendering
                            </p>
                            <p className="basic-bold">
                              S/W (3차원 비정형 데이터 렌더링 소프트웨어)
                            </p>
                            <p className="basic-bold">_v1.0</p>
                          </div>
                        </div>
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              XR(확장현실)기반 3차원 모델 가시화
                            </p>
                            <p className="basic-bold">프로그램 v1.0</p>
                          </div>
                        </div>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              DiTAP 3D Tiles Converter
                            </p>
                            <p className="basic-bold">
                              (타이탭 쓰리디 타일쓰 비아이엠 모델 경량화
                            </p>
                            <p className="basic-bold">소프트 웨어)_v2.0</p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">09월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              메타버스를 위한 건축물 실내 외
                            </p>
                            <p className="basic-bold">
                              투어링 가이드 마크 시스템
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">08월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              투명모니터와 3D 깊이카메라를 이용한
                            </p>
                            <p className="basic-bold">
                              관리자 시선 맞춤형 정보제공 시스템
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">06월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              XR룸을 이용한 무한공간 구현 및
                            </p>
                            <p className="basic-bold">컨트롤 제어 시스템</p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">05월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              3차원 점군 데이터 고속 동적 가시화 방안 및
                            </p>
                            <p className="basic-bold">
                              투명 메쉬 데이터를 이용한 함수 시스템
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">03월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAP CM(디지털 트윈 건설관리) v1.0
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          저작권 등록 - DiTAP4Unity Asset 다이탭포유니티 에셋
                        </p>
                        <p className="basic-bold">
                          저작권 등록 - DiTAP_Unity 다이탭 유니티
                        </p>
                      </div>
                    </li>

                    <li className="about-history-item">
                      <p className="about-history-name">01월</p>
                      <div className="about-history-cont">
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              DiTAP 3D Tiles Converter
                            </p>
                            <p className="basic-bold">
                              (타이탭 쓰리디 타일쓰 비아이엠 모델
                            </p>
                            <p className="basic-bold">
                              경량화 소프트 웨어)_v1.0
                            </p>
                          </div>
                        </div>
                        <p className="basic-bold">
                          저작권 등록 - XR기반 통합 플랫폼_v1.0
                        </p>
                      </div>
                    </li>
                  </ul>
                </li>
                <li className="about-historys-item">
                  <h3 className="about-history-title">2021</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">12월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          특허 등록 - 인공 지능을 이용한 비대면 중개서비스
                          시스템
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">07월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          2021 스마트 국토엑스포 참가
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">06월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          특허 등록 - 인공지능을 이용한 시설물 3차원 관리시스템
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">04월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          본사(경기도 성남시 분당구 대왕판교로
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          660동 A동 1108호)로 이전
                        </p>
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              인공지능을 이용하는 항공촬영 수치 표면 모델의
                            </p>
                            <p className="basic-bold">
                              수치표고모델 변환 시스템
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">02월</p>
                      <div className="about-history-cont">
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              DiTAP_AM_Clinet(다이탭 자산관리
                            </p>
                            <p className="basic-bold">
                              패키지 클라이언트)_v1.0
                            </p>
                          </div>
                        </div>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              DiTAP_AM_Server(다이탭 자산관리
                            </p>
                            <p className="basic-bold">패키지 서버)_v1.0</p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li className="about-historys-item">
                  <h3 className="about-history-title">2020</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">11월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          성과보상 기금(내일 채움 공제) 가입
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">10월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          벤처기업 인증, 성과 공유 기업 확인
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">09월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          한국연구개발 서비스협회 가입
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">08월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              휴대 단말기를 이용한 인공지능
                            </p>
                            <p className="basic-bold">
                              기반 실내 위치 측위 시스템
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">07월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          공학 연구 및 기술 기반 서비스의 직접 생산 등록
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">05월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          본사(경기도 성남시 분당구 판교역로 240, A동 410-6호
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          삼평동, 삼환 하이펙스)로 이전
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          (주)타이탄 업무협약(MOU)
                        </p>
                        <p className="basic-bold">(주)한맥기술 업무협약(MOU)</p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">03월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          백석대학교 업무협약(MOU)
                        </p>
                        <p className="basic-bold">대표이사 이종훈 취임</p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">02월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          제주대학교 업무협약(MOU)
                        </p>
                        <p className="basic-bold">
                          경기도 성남시 분당구 판교역로 192번 길 16, 8층 806호
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          A116(삼평동, 판교타워) 헬리오센(주) 설립
                        </p>
                        <p className="basic-bold">
                          헬리오센 주식회사 / 대표이사 유재현 설립
                        </p>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </>
      ) : (
        <>
          {/* 모바일 */}
          <div>
            <div className="about-heliosen-wrap inner">
              <div>
                <h2 className="about-welcome">
                  <p className="txt">헬리오센을 방문해주신</p>
                  <p className="txt">여러분 진심으로</p>
                  <p className="txt">환영합니다.</p>
                </h2>
              </div>
              <div className="basic-banner about-banner">
                <h2 className="basic-banner-title">
                  <p className="txt">We Connect Space</p>
                  <p className="txt">And Humans</p>
                  <p className="basic-banner-subtitle">
                    공간과 인간을 연결하는 가치 창조자 HELIOSEN
                  </p>
                </h2>
              </div>
              <div className="about-heliosen">
                <h3 className="about-heliosen-title">
                  <p className="txt">Heliosen은 Helios(그리스 신화의</p>
                  <p className="txt">태양신)와 Sense(감각)의 합성어입니다.</p>
                </h3>
                <div className="about-heliosen-top-cont">
                  <p>
                    바깥으로는 디지털 트윈과 메타버스 시대에 맞는 직관적인
                    표현과 통찰력 있는
                  </p>
                  <p>
                    분석기술을 제공하여 공간과 인간을 연결하고, 내적으로는
                    배려와 공감과 상호 존중을
                  </p>
                  <p>
                    바탕으로 창의적이고 진취적 마인드를 갖춘 전문가 집단으로
                    능력 개발과 발휘를 통하여
                  </p>
                  <p>사회와 같이 성장하는 회사가 되고자 합니다.</p>
                  <div className="about-heliosen-bottom-cont">
                    <p>여러분의 관심을 바탕으로 신뢰를 쌓으며,</p>
                    <p>
                      인간과 공간과 시간 사이를 좁히는 가치 창출에
                      노력하겠습니다.
                    </p>
                  </div>
                  <p>
                    <b className="basic-bold">감사합니다.</b>
                  </p>
                  <p className="about-ceo">대표이사 이종훈</p>
                </div>
              </div>
            </div>
          </div>
          <div className="inner">
            <div className="about-overview">
              <div className="about-overview-txt-wrap">
                <div className="basic-banner about-overview-img">
                  <h2 className="basic-banner-title">
                    <p className="txt">기업 개요</p>
                    <p className="basic-banner-subtitle">
                      <span className="txt">
                        디지털 트윈 선도 업체로 분야의
                      </span>
                      <span className="txt">다양한 경험과 기술을 보유한 </span>
                      <span className="txt">인원으로 구성되어 있습니다.</span>
                    </p>
                  </h2>
                </div>
                <div>
                  <ul className="about-overview-list">
                    <li className="about-overview-item">
                      <p className="about-overview-name">회사명</p>
                      <h4 className="about-overview-cont">헬리오센(주)</h4>
                    </li>
                    <li className="about-overview-item">
                      <p className="about-overview-name">업종</p>
                      <h4 className="about-overview-cont">
                        정보통신업 / 서비스업
                      </h4>
                    </li>
                    <li className="about-overview-item">
                      <p className="about-overview-name">설립일</p>
                      <h4 className="about-overview-cont">2020. 02. 04</h4>
                    </li>
                    <li className="about-overview-item">
                      <p className="about-overview-name">대표이사</p>
                      <h4 className="about-overview-cont">이종훈</h4>
                    </li>
                    <li className="about-overview-item about-overview-img-item">
                      <p className="about-overview-img about-overview-patent-img"></p>
                      <div className="about-overview-cont-wrap">
                        <p className="about-overview-cont">특허 등록</p>
                        <h4 className="about-overview-cont">14 건</h4>
                      </div>
                    </li>
                    <li className="about-overview-item about-overview-img-item">
                      <p className="about-overview-img about-overview-copyright-img"></p>
                      <div className="about-overview-cont-wrap">
                        <p className="about-overview-cont">저작권 등록</p>
                        <h4 className="about-overview-cont">28 건</h4>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div>
              <ul className="about-historys-list">
                <li className="about-historys-item">
                  <h3 className="about-history-title">2024</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">11월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div style={{ marginBottom: "20px" }}>
                            <p className="basic-bold">
                              3차원 공간정보데이터의 고속연산 처리를 위한
                              다중검증 시스템
                            </p>
                          </div>
                        </div>
                        <p className="basic-bold">
                          제16회 2024 K-GEO Festa 참가
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">10월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div style={{ marginBottom: "20px" }}>
                            <p className="basic-bold">
                              3D Tiles Next 생성 소프트웨어 v1.0
                            </p>
                            <p className="basic-bold">
                              (쓰리디 타일즈 넥스트 생성 소프트웨어 버전 1.0)
                            </p>
                          </div>
                        </div>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          연세대학교 의료원 산학협력단 공동연구개발협약 체결
                        </p>
                        <p className="basic-bold">
                          'DiTAP Builder v1.0' 나라장터 "상용소프트웨어
                        </p>
                        <p className="basic-bold">제3자단가 계약" 완료</p>
                      </div>
                    </li>
                    {moreBtn[4] ? (
                      <>
                        <li className="about-history-item">
                          <p className="about-history-name">09월</p>
                          <div className="about-history-cont">
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              성남시 측량업-공공측량업 등록
                            </p>
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              국토지리정보원 측량업-수치지도제작업 등록
                            </p>
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              국토지리정보원 측량업-영상처리업 등록
                            </p>
                            <div className="about-history-detail">
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div style={{ marginBottom: "20px" }}>
                                <p className="basic-bold">
                                  Smart Hospital Vulnerable Simulation
                                </p>
                                <p className="basic-bold">
                                  System v1 (스마트 병원 취약지점 분석
                                </p>
                                <p className="basic-bold">시뮬레이션 시스템)</p>
                              </div>
                            </div>
                            <div className="about-history-detail">
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div style={{ marginBottom: "20px" }}>
                                <p className="basic-bold">
                                  Smart Hospital Indoor Viewer
                                </p>
                                <p className="basic-bold">
                                  System v1.0(스마트 병원 실내 데이터
                                </p>
                                <p className="basic-bold">가시화 시스템)</p>
                              </div>
                            </div>
                            <div className="about-history-detail">
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div style={{ marginBottom: "20px" }}>
                                <p className="basic-bold">
                                  Smart Hospital RTLS System v1.0
                                </p>
                                <p className="basic-bold">
                                  (스마트 병원 이동객체 시스템)
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">08월</p>
                          <div className="about-history-cont">
                            <p className="basic-bold">
                              국토교통부 초경량비행장치사용사업 등록
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">07월</p>
                          <div className="about-history-cont">
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              국토지리정보원 측량업-지도제작업 등록
                            </p>
                            <p className="basic-bold">
                              YTN '최강기업' 프로그램 헬리오센 출연
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">06월</p>
                          <div className="about-history-cont">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  3차원 디지털 트윈 플랫폼 서비스를 위한 사용자
                                </p>
                                <p className="basic-bold">
                                  솔루션 및 클라우드 구독용 서비스의 제공 방법
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">05월</p>
                          <div className="about-history-cont">
                            <p className="basic-bold">
                              한국일보 '디지털 이노베이션 대상' 수상
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">03월</p>
                          <div className="about-history-cont">
                            <p className="basic-bold">
                              본사 이전 &#40;경기도 성남시 분당구 판교역로 230
                            </p>
                            <p className="basic-bold">
                              삼환하이펙스 B동 B101호&#41;
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">01월</p>
                          <div className="about-history-cont">
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              ISO9001 인증 획득
                            </p>
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              'DiTAP_Builder, JS, for Unity' 나라장터 등록 완료
                            </p>
                            <p className="basic-bold">청년친화강소기업 선정</p>
                          </div>
                        </li>
                        <li className="about-history-more">
                          <button
                            onClick={() => {
                              onMoreBtn(4, !moreBtn[4]);
                            }}
                            className="about-history-btn on"
                          >
                            <span>접기</span>
                          </button>
                        </li>
                      </>
                    ) : (
                      <li className="about-history-more">
                        <button
                          onClick={() => {
                            onMoreBtn(4, !moreBtn[4]);
                          }}
                          className="about-history-btn"
                        >
                          <span>더보기</span>
                        </button>
                      </li>
                    )}
                  </ul>
                </li>
                <li className="about-historys-item">
                  <h3 className="about-history-title">2023</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">12월</p>
                      <div className="about-history-cont">
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              XR(확장현실)기반 3차원 모델 가시화
                            </p>
                            <p className="basic-bold">프로그램 v2.0</p>
                          </div>
                        </div>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              IndoorHospital(인도어호스피탈) v0.1
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">11월</p>
                      <div className="about-history-cont">
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          GS인증 1급 취득 - DiTAP Builder (다이탭 빌더)
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          GS인증 1급 취득 - DiTAP JS (다이탭 제이에스)
                        </p>
                        <p
                          className="basic-bold"
                          style={{ marginBottom: "20px" }}
                        >
                          GS인증 1급 취득 - DiTAP Unity (다이탭 유니티)
                        </p>
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              CAD(캐드)BIM(빌딩정보모델링) 데이터
                            </p>
                            <p className="basic-bold">
                              대용량 검증처리 모듈 v1.0
                            </p>
                          </div>
                        </div>
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              CAD(캐드)BIM(빌딩정보모델링)데이터
                            </p>
                            <p className="basic-bold">언팩 &정합모듈 v1.0</p>
                          </div>
                        </div>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              25.DiTAP 3D Converter(다이탭 쓰리디
                            </p>
                            <p className="basic-bold">
                              타일쓰 비아이엠 모델 경량화 소프트웨어)
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    {moreBtn[3] ? (
                      <>
                        <li className="about-history-item">
                          <p className="about-history-name">09월</p>
                          <div className="about-history-cont">
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP for Unity v1.0 (다이탭 포 유니티)
                                </p>
                              </div>
                            </div>
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  R-tree 기반을 활용한 3차원 건축물 실내외
                                </p>
                                <p className="basic-bold">
                                  3D Tiles 자동 생성 시스템
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">08월</p>
                          <div className="about-history-cont">
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP JS v1.0 (다이탭 제이에스)
                                </p>
                              </div>
                            </div>
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP Builder v1.0 (다이탭 빌더)
                                </p>
                              </div>
                            </div>

                            <p className="basic-bold">
                              기술혁신형 중소기업(Inno-Biz) 인증
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">06월</p>
                          <div className="about-history-cont">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  유니티(Unity)엔진을 이용한 3차원 지구
                                </p>
                                <p className="basic-bold">
                                  XR 가시화 장치 및 방법
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">05월</p>
                          <div className="about-history-cont">
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">DiTAPforUnity XR</p>
                              </div>
                            </div>
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAPforUnity XR - Architecture
                                </p>
                              </div>
                            </div>
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAPforUnity XR - Museum
                                </p>
                              </div>
                            </div>
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAPforUnity XR - UrbanPlanning
                                </p>
                              </div>
                            </div>
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  3D Tiles 자동화 모듈(3차원 타일 자동화 모듈)
                                </p>
                              </div>
                            </div>
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP Server 대용량 데이터 파이프라인
                                </p>
                              </div>
                            </div>

                            <p className="basic-bold">
                              (다이탭 서버 대용량 데이터 파이프라인)
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">04월</p>
                          <div className="about-history-cont">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  비공간정보와 3차원 공간정보 매핑데이터를
                                </p>
                                <p className="basic-bold">
                                  가시화 시킨 검증기술 시스템 및 방법
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">03월</p>
                          <div className="about-history-cont">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  비공간정보와 3차원 공간정보 매핑데이터의
                                </p>
                                <p className="basic-bold">
                                  신뢰도를 향상시킨 고속검색 시스템 및 방법
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-more">
                          <button
                            onClick={() => {
                              onMoreBtn(3, !moreBtn[3]);
                            }}
                            className="about-history-btn on"
                          >
                            <span>접기</span>
                          </button>
                        </li>
                      </>
                    ) : (
                      <li className="about-history-more">
                        <button
                          onClick={() => {
                            onMoreBtn(3, !moreBtn[3]);
                          }}
                          className="about-history-btn"
                        >
                          <span>더보기</span>
                        </button>
                      </li>
                    )}
                  </ul>
                </li>
                <li className="about-historys-item">
                  <h3 className="about-history-title">2022</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">12월</p>
                      <div className="about-history-cont">
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              3D Unstructured data rendering
                            </p>
                            <p className="basic-bold">
                              S/W (3차원 비정형 데이터 렌더링 소프트웨어)
                            </p>
                            <p className="basic-bold">_v1.0</p>
                          </div>
                        </div>
                        <div
                          className="about-history-detail"
                          style={{ marginBottom: "20px" }}
                        >
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              XR(확장현실)기반 3차원 모델 가시화
                            </p>
                            <p className="basic-bold">프로그램 v1.0</p>
                          </div>
                        </div>
                        <div className="about-history-detail">
                          <p className="basic-bold">저작권 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              DiTAP 3D Tiles Converter
                            </p>
                            <p className="basic-bold">
                              (타이탭 쓰리디 타일쓰 비아이엠 모델 경량화
                            </p>
                            <p className="basic-bold">소프트 웨어)_v2.0</p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">09월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              메타버스를 위한 건축물 실내 외
                            </p>
                            <p className="basic-bold">
                              투어링 가이드 마크 시스템
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    {moreBtn[2] ? (
                      <>
                        <li className="about-history-item">
                          <p className="about-history-name">08월</p>
                          <div className="about-history-cont">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  투명모니터와 3D 깊이카메라를 이용한
                                </p>
                                <p className="basic-bold">
                                  관리자 시선 맞춤형 정보제공 시스템
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">06월</p>
                          <div className="about-history-cont">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  XR룸을 이용한 무한공간 구현 및
                                </p>
                                <p className="basic-bold">컨트롤 제어 시스템</p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">05월</p>
                          <div className="about-history-cont">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  3차원 점군 데이터 고속 동적 가시화 방안 및
                                </p>
                                <p className="basic-bold">
                                  투명 메쉬 데이터를 이용한 함수 시스템
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">03월</p>
                          <div className="about-history-cont">
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP CM(디지털 트윈 건설관리) v1.0
                                </p>
                              </div>
                            </div>
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP4Unity Asset 다이탭포유니티 에셋
                                </p>
                              </div>
                            </div>
                            <div className="about-history-detail">
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP_Unity 다이탭 유니티
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>

                        <li className="about-history-item">
                          <p className="about-history-name">01월</p>
                          <div className="about-history-cont">
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP 3D Tiles Converter(타이탭 쓰리디 타일쓰
                                  비아이엠 모델 경량화 소프트 웨어)_v1.0
                                </p>
                              </div>
                            </div>
                            <div className="about-history-detail">
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  XR기반 통합 플랫폼_v1.0
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-more">
                          <button
                            onClick={() => {
                              onMoreBtn(2, !moreBtn[2]);
                            }}
                            className="about-history-btn on"
                          >
                            <span>접기</span>
                          </button>
                        </li>
                      </>
                    ) : (
                      <li className="about-history-more">
                        <button
                          onClick={() => {
                            onMoreBtn(2, !moreBtn[2]);
                          }}
                          className="about-history-btn"
                        >
                          <span>더보기</span>
                        </button>
                      </li>
                    )}
                  </ul>
                </li>
                <li className="about-historys-item">
                  <h3 className="about-history-title">2021</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">12월</p>
                      <div className="about-history-cont">
                        <div className="about-history-detail">
                          <p className="basic-bold">특허 등록 -&nbsp;</p>
                          <div>
                            <p className="basic-bold">
                              인공 지능을 이용한 비대면 중개서비스 시스템
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">07월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          2021 스마트 국토엑스포 참가
                        </p>
                      </div>
                    </li>
                    {moreBtn[1] ? (
                      <>
                        <li className="about-history-item">
                          <p className="about-history-name">06월</p>
                          <div className="about-history-cont">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  인공지능을 이용한 시설물 3차원 관리시스템
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">04월</p>
                          <div className="about-history-cont">
                            <p className="basic-bold">
                              본사(경기도 성남시 분당구 대왕판교로
                            </p>
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              660동 A동 1108호)로 이전
                            </p>
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  인공지능을 이용하는 항공촬영 수치 표면 모델의
                                </p>
                                <p className="basic-bold">
                                  수치표고모델 변환 시스템
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">02월</p>
                          <div className="about-history-cont">
                            <div
                              className="about-history-detail"
                              style={{ marginBottom: "20px" }}
                            >
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP_AM_Clinet(다이탭 자산관리
                                </p>
                                <p className="basic-bold">
                                  패키지 클라이언트)_v1.0
                                </p>
                              </div>
                            </div>
                            <div className="about-history-detail">
                              <p className="basic-bold">저작권 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  DiTAP_AM_Server(다이탭 자산관리
                                </p>
                                <p className="basic-bold">패키지 서버)_v1.0</p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-more">
                          <button
                            onClick={() => {
                              onMoreBtn(1, !moreBtn[1]);
                            }}
                            className="about-history-btn on"
                          >
                            <span>접기</span>
                          </button>
                        </li>
                      </>
                    ) : (
                      <li className="about-history-more">
                        <button
                          onClick={() => {
                            onMoreBtn(1, !moreBtn[1]);
                          }}
                          className="about-history-btn"
                        >
                          <span>더보기</span>
                        </button>
                      </li>
                    )}
                  </ul>
                </li>
                <li className="about-historys-item">
                  <h3 className="about-history-title">2020</h3>
                  <ul>
                    <li className="about-history-item">
                      <p className="about-history-name">11월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          성과보상 기금(내일 채움 공제) 가입
                        </p>
                      </div>
                    </li>
                    <li className="about-history-item">
                      <p className="about-history-name">10월</p>
                      <div className="about-history-cont">
                        <p className="basic-bold">
                          벤처기업 인증, 성과 공유 기업 확인
                        </p>
                      </div>
                    </li>

                    {moreBtn[0] ? (
                      <>
                        <li className="about-history-item">
                          <p className="about-history-name">09월</p>
                          <div className="about-history-cont">
                            <p className="basic-bold">
                              한국연구개발 서비스협회 가입
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">08월</p>
                          <div className="about-history-cont about-history-item">
                            <div className="about-history-detail">
                              <p className="basic-bold">특허 등록 -&nbsp;</p>
                              <div>
                                <p className="basic-bold">
                                  휴대 단말기를 이용한 인공지능
                                </p>
                                <p className="basic-bold">
                                  기반 실내 위치 측위 시스템
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">07월</p>
                          <div className="about-history-cont">
                            <p className="basic-bold">
                              공학 연구 및 기술 기반 서비스의 직접 생산 등록
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">05월</p>
                          <div className="about-history-cont">
                            <p className="basic-bold">
                              본사(경기도 성남시 분당구 판교역로 240, A동
                              410-6호
                            </p>
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              삼평동, 삼환 하이펙스)로 이전
                            </p>
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              (주)타이탄 업무협약(MOU)
                            </p>
                            <p className="basic-bold">
                              (주)한맥기술 업무협약(MOU)
                            </p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">03월</p>
                          <div className="about-history-cont">
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              백석대학교 업무협약(MOU)
                            </p>
                            <p className="basic-bold">대표이사 이종훈 취임</p>
                          </div>
                        </li>
                        <li className="about-history-item">
                          <p className="about-history-name">02월</p>
                          <div className="about-history-cont">
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              제주대학교 업무협약(MOU)
                            </p>
                            <p
                              className="basic-bold"
                              style={{ marginBottom: "20px" }}
                            >
                              경기도 성남시 분당구 판교역로 192번 길 16, 8층
                              806호 A116(삼평동, 판교타워) 헬리오센(주) 설립
                            </p>
                            <p className="basic-bold">
                              헬리오센 주식회사 / 대표이사 유재현 설립
                            </p>
                          </div>
                        </li>
                        <li className="about-history-more">
                          <button
                            onClick={() => {
                              onMoreBtn(0, !moreBtn[0]);
                            }}
                            className="about-history-btn on"
                          >
                            <span>접기</span>
                          </button>
                        </li>
                      </>
                    ) : (
                      <li className="about-history-more">
                        <button
                          onClick={() => {
                            onMoreBtn(0, !moreBtn[0]);
                          }}
                          className="about-history-btn"
                        >
                          <span>더보기</span>
                        </button>
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default AboutMain;
